var StudentHour = function (src) {
    var self = this;
    src = src || {};
    self.StudentHoursId = src.NPHoursId || 0;
    self.StudentId = src.StudentId || 0;
    self.CenterId = src.CenterId || 0;
    self.Experience = src.Experience || '';
    self.StudentResourceId = src.StudentResourceId || 0;
    self.FocusArea  = src.FocusArea||'';
    self.FunctionalAreaId = src.FunctionalAreaId || 0;
    self.FunctionalArea = src.FunctionalArea || '';
    self.DispatchDate = src.DispatchDate || '';
    self.ReturnedDate = src.ReturnedDate || 0;
    self.CalendarYear = src.CalendarYear || 0;
    self.Hours = src.Hours || 0;
    self.FirstName = src.FirstName || '';
    self.MiddleInitial = src.MiddleInitial || '';
    self.LastName = src.LastName || '';
    self.ForestName = src.ForestName || '';
    self.PartnerOrg = src.PartnerOrg || '';
    self.ProjectSite = src.ProjectSite || '';
    self.ProjectName = src.ProjectName || '';
    self.IsPLC = src.IsPLC || true;
    self.Comments = src.Comments || '';
    self.Active = src.Active || 1;
    self.Deleted = src.Deleted || 0;
    self.Creator = src.Creator || '';
    self.LastModifiedBy = src.LastModifiedBy || '';
    self.CreatedDate = src.CreatedDate || new Date();
    self.CreatedDateString = src.CreatedDateString || '';
    self.CreatedBy = src.CreatedBy || '';
    self.LastUpdated = src.LastUpdated || new Date();
    self.LastUpdatedString = src.LastUpdatedString || '';
    self.LastUpdatedBy = src.LastUpdatedBy || '';
    self.UpdatingApp = src.UpdatingApp || '';
    return self;
};
StudentHour.prototype.fullName = function () {
    return (this.LastName || '') + ', ' + this.FirstName + ' ' + (this.MiddleInitial || '');
};
StudentHour.prototype.dispatchDateISO = function () {
    if (this.DispatchDate == '')
        return '';
    else
        return new Date(this.DispatchDate);
};
StudentHour.prototype.returnedDateISO = function () {
    if (this.ReturnedDate == '')
        return '';
    else
        return new Date(this.ReturnedDate);
};
angular.module('jcsfApp').value('StudentHour', StudentHour);